import React, {useEffect,useState} from 'react';
import {apiFetch} from '../../api/api';

export default function MovePrintManager({device,onClose,onRequested}) {
  const [destinations,setDestinations]=useState([]);
  const [destination,setDestination]=useState('');
  const [busy,setBusy]=useState(false);
  const [submitted,setSubmitted]=useState(false);
  const [error,setError]=useState('');
  useEffect(()=>{
    let current=true;
    apiFetch('/api/printmanager/transfer/destinations').then(rows=>{
      if(current)setDestinations(rows.filter(o=>String(o._id)!==String(device.orgId)));
    }).catch(()=>{if(current)setError('Unable to load destination organizations.');});
    return ()=>{current=false;};
  },[device.orgId]);
  async function confirm(){
    const selected=destinations.find(o=>o._id===destination);
    if(!selected||!window.confirm(`Move ${device.deviceName||device.deviceId} to ${selected.organization}? Source access will be revoked after work drains. History stays in the source organization.`))return;
    setBusy(true);setSubmitted(true);setError('');
    try{
      await apiFetch('/api/printmanager/transfer/move',{method:'POST',body:{deviceId:device.deviceId,destinationOrgId:destination,confirm:true}});
      onRequested();onClose();
    }catch{setError('Move blocked or not acknowledged. Retry the same destination; active work must finish first.');}
    finally{setBusy(false);}
  }
  return <section role="dialog" aria-modal="true" aria-label="Move to Another Organization">
    <h2>Move to Another Organization</h2>
    <p>{device.deviceName||device.deviceId}</p>
    <label>Destination organization <select value={destination} disabled={busy||submitted} onChange={e=>setDestination(e.target.value)}>
      <option value="">Select destination</option>{destinations.map(o=><option key={o._id} value={o._id}>{o.organization}</option>)}
    </select></label>
    <p>The same Release and Claim lifecycle preserves source history. Destination printing waits for authenticated discovery.</p>
    {error&&<p role="alert">{error}</p>}
    <button disabled={!destination||busy} onClick={confirm}>Confirm Move</button>
    <button disabled={busy} onClick={onClose}>Close</button>
  </section>;
}
